/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Badge, Toast } from '@hb/coffee';

import { RouterV2Enum } from '@/router/router-names';
import { Component, Vue } from 'vue-property-decorator';
import platform from '@/shared/utils/platform';
import { styleNumPxToVm } from '@/shared/utils/style-unit';
import { namespace } from 'vuex-class';
import { jumpToNewVersion } from '@/shared/utils/jumpTo';
import { NewVersionEnum } from '@/enums/newVersionRoute';
import { financeWeiXinMpUrlScheme } from '@/constant';
import { MyProfileUnitItem } from '../../types';
import style from './index.module.scss';
import commonStyle from '../../index.module.scss';

const MyProfileStore = namespace('myProfile');

@Component
export default class ToolList extends Vue {
  @MyProfileStore.State hasEquityOrders!: boolean;

  @MyProfileStore.Action needDepsitEntry!: () => Promise<void>;

  @MyProfileStore.Action hasEquityOrdersReq!: () => Promise<void>;


  private get showItems(): MyProfileUnitItem[] {
    const data = [
      {
        name: '帮助中心',
        image: require('./images/help-center@2x.png'),
        onClick: (_this: ToolList) => {
          _this.$router.push(RouterV2Enum.helpCenter);
        },
      },
      {
        name: '意见反馈',
        image: require('./images/feedback@2x.png'),
        onClick: (_this: ToolList) => {
          _this.$router.push(RouterV2Enum.feedBack);
        },
      },
      {
        name: '优惠券',
        image: require('./images/coupon.png'),
        hide: !(platform.isAlipayMini || platform.isDingTalk),
        onClick: (_this: ToolList) => {
          _this.$router.push(RouterV2Enum.myCoupon);
        },
      },
      {
        name: '结清证明',
        image: require('./images/payoff@3x.png'),
        onClick: () => {
          this.$ubtPageButton('finance_mypage_proof');
          if (platform.isWechatMini) {
            Toast('结清证明开具事宜暂请咨询客服');
          } else {
            jumpToNewVersion(NewVersionEnum.ContractSettleList, false);
          }
        },
      },
      {
        name: '防诈指南',
        image: require('./images/fraud@3x.png'),
        onClick: (_this: ToolList) => {
          this.$ubtPageButton('finance_loan_mypage_fraudPrevention');
          _this.$router.push(RouterV2Enum.antiFraudCenter);
        },
      },
      {
        name: '营销设置',
        image: require('./images/marketing@3x.png'),
        onClick: () => {
          this.$ubtPageButton('finance_loan_mypage_marketing');
          jumpToNewVersion(NewVersionEnum.MARKETING_SETTINGS, false);
        },
        hide: platform.isSkApp,
      },
      {
        name: '红包明细',
        image: require('./images/bonus-list@3x.png'),
        onClick: () => {
          this.$ubtPageButton('finance_myPage_redPacketDetails');
          jumpToNewVersion(NewVersionEnum.REPAYMENT_BONUS_LIST, false);
        },
        hide: !platform.isEasyBike,
      },
      // TODO: 暂时关闭微信客服,后续再开启
      // {
      //   name: '微信客服',
      //   image: require('./images/wecom.png'),
      //   badge: '1V1服务',
      //   onClick: () => {
      //     this.$ubtPageButton('finance_loan_myPage_wecomButton');

      //     // 跳转小程序联系我的页面
      //     const path = 'pages/contact-us/index';
      //     const query = 'source=myProfile'; // 通过参数标识目标为客服
      //     const schemeUrl =
      // `${financeWeiXinMpUrlScheme}&path=${path}&query=${encodeURIComponent(query)}`;
      //     window.location.href = schemeUrl;
      //   },
      // },
    ];
    return data.filter((item) => item.hide !== true);
  }

  private async created() {
    await this.needDepsitEntry();
    await this.hasEquityOrdersReq();
  }

  /**
   *徽标异步使用同步导入样式避免样式抖动
   */
  private render() {
    return (
      <div class={commonStyle.sectionContainer}>
        <div class={[commonStyle.header, style.myServer]}>我的服务</div>
        <ul class={[style.toolList, commonStyle.categoryList]}>
          {this.showItems.map((item) => (
            <li
              key={item.name}
              style={item.image && { backgroundImage: `url(${item.image})` }}
              onClick={this.onClick.bind(this, item)}
            >
              {item.badge && (
                <Badge
                  class={style.iconBadge}
                  shape="bubble"
                  style={{
                    position: 'absolute',
                    top: `${styleNumPxToVm(-8)}vw`,
                    right: `${styleNumPxToVm(-12)}vw`,
                    zIndex: 1,
                  }}
                >
                  {item.badge}
                </Badge>
              )}
              {item.name}
            </li>
          ))}
        </ul>
      </div>
    );
  }

  private onClick(item: MyProfileUnitItem) {
    this.$ubtPageButton('finance_onMyProfileToolClick', 'toolName', item.name);
    item.onClick(this);
  }
}
